mutation UpdateCurrentPlatform($input: UpdateCurrentPlatformInput!) {
  updateCurrentPlatform(input: $input) {
    id
    title
    description
    gaId
    googleSiteVerification
    customHTML
    customHead
    logoId
    faviconId
    iconId
    languageId
    language {
      id
      code
      title
    }
    hideableHeader
    isLikesEnabled
    features
    isLiveReactionsEnabled
    liveReactionPhrases
    liveReactionEmojis
    parallelPremiumViewLimit
    streamSignalAlertsEnabled
    isFavoritesEnabled
    isFeaturedVideosEnabled
    acceptTermsOfServiceOnSignIn
    defaultRowSize
    theme {
      palette {
        type
        primary
        secondary
        backgroundColor
      }
      typography {
        fontFamily
        headingFontFamily
      }
    }
    footer {
      title
      subtitle
      social {
        type
        link
      }
    }
    privacyPolicyUrl
    termsOfServiceUrl
    refundPolicyUrl
    legalEntity {
      name
      address
      registrationNumber
      email
      phone
    }
    customTerms {
      label
      url
    }
  }
}

